import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from "./redux/store"
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { ThemeToogleProvider } from './hooks/themeContext';

const helmetContext = {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeToogleProvider>
      <PersistGate loading={null} persistor={persistor}>
        <React.StrictMode>
          <HelmetProvider context={helmetContext}>
            <App />
          </HelmetProvider>
        </React.StrictMode>
      </PersistGate>
    </ThemeToogleProvider>
  </Provider>
);

reportWebVitals();
